import type { StickyFooterProps } from './data';

import React from 'react';

import ProductCounter from '../ProductCounter';

import { Stack, Text } from '@/components';
import { toToman } from '@/utils';

const StickyFooter: StickyFooterProps = ({
  product,
  onNotSelectedVariant,
  selectedVariantCode,
  isLoading,
}) => {
  const isViewProduct = product.type === 'view';
  const isOutOfStock = !(product.inventory.is_available || isViewProduct);

  return (
    <Stack
      direction="column"
      display={{ md: 'none' }}
      bg="white"
      py="17px"
      px="20px"
      borderTop="1px solid"
      borderColor="gray.600"
      position="fixed"
      bottom="0"
      w="full"
      zIndex="overlay"
    >
      <Stack
        direction="row"
        width="full"
        align="center"
        justify={isOutOfStock ? 'center' : 'space-between'}
      >
        <ProductCounter
          product={product}
          selectedVariantCode={selectedVariantCode}
          onNotSelectedVariant={onNotSelectedVariant}
          isLoading={isLoading}
        />
        {!isOutOfStock && (
          <Stack direction="column" gap="0" align="flex-end">
            <>
              <Text fontSize={{ base: 'sm', md: 'md' }} fontWeight="500">
                {toToman(
                  product.pricing
                    ? product.pricing.payable_price
                    : product.price
                )}
              </Text>
              {product.pricing &&
                product.pricing.payable_price !== product.price && (
                  <Text
                    fontSize="xs"
                    color="gray.700"
                    pl="2"
                    textDecor="line-through"
                  >
                    {toToman(product.price)}
                  </Text>
                )}
            </>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default StickyFooter;
